/*
 * VNCcommander - The brilliant centerpiece of VNClagoon with your activity stream and much more.
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { CommonUtils } from "src/app/common/utils/common-util";
import { AppRepository } from "src/app/repositories/app.repository";

@Component({
  selector: "vp-mobile-preferences-dialog",
  templateUrl: "./mobile-preferences-dialog.component.html"
})
export class MobilePreferencesDialogComponent implements OnInit, OnDestroy {
  private isAlive$ = new Subject<boolean>();

  constructor(
    public dialogRef: MatDialogRef<MobilePreferencesDialogComponent>,
    private ngZone: NgZone,
    private changeDetectorRef: ChangeDetectorRef,
    private appRepository: AppRepository
  ) {
    // this.mailBroadcaster.on<any>(BroadcastKeys.HIDE_ABOUT_DIALOG).pipe(takeUntil(this.isAlive$)).subscribe(res => {
    //   this.ngZone.run(() => {
    //     this.close();
    //   });
    // });
  }

  ngOnInit() {
    if (CommonUtils.isOnIOS()) {
      setTimeout(() => {
        document.querySelector(".cdk-global-overlay-wrapper").removeAttribute("style");
      }, 50);
    }
  }

  ngOnDestroy() {
    this.isAlive$.next(false);
    this.isAlive$.unsubscribe();
  }

  close(): void {
    this.dialogRef.close();
  }

  underDevelopment() {
    this.appRepository.underDevelopment();
  }
}
